import axios from "axios";
import { createBlobFile } from "@/composables";

export default {
  data: () => ({
    percentageDownload: 0,
    isDownloading: false,
  }),
  methods: {
    async downloadFile(url, type, name) {
      this.isDownloading = true;
      await axios
        .get(url, {
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            const total = progressEvent.total;
            const current = progressEvent.loaded;

            const percentCompleted = Math.floor((current / total) * 100);
            this.percentageDownload = percentCompleted;
          },
        })
        .then((res) => {
          createBlobFile(res.data, type, name);
          this.isDownloading = false;
        })
        .catch(() => {
          this.isDownloading = false;
        });
    },
  },
};
